import { CALLBACK_ARGUMENT, ERROR_ACTION, WAIT_FOR_ACTION } from "redux-wait-for-action";

export const SET_RAKEZ_DATA_LOADING = "SET_RAKEZ_DATA_LOADING";
export const SET_RAKEZ_DATA = "SET_RAKEZ_DATA";
export const SET_RAKEZ_ERROR = "SET_RAKEZ_ERROR";
export const RESET_RAKEZ_STATES = "RESET_RAKEZ_STATES";
export const SET_RAKEZ_FETCH_COMPLETED = "SET_RAKEZ_FETCH_COMPLETED";
export const RAKEZ_FETCH_DATA_REQUEST = "RAKEZ_FETCH_DATA_REQUEST";

export const fetchRakezData = (prospectId, licenseNo, licenseIssuingAuthority) => ({
  type: RAKEZ_FETCH_DATA_REQUEST,
  [WAIT_FOR_ACTION]: SET_RAKEZ_DATA,
  [ERROR_ACTION]: SET_RAKEZ_ERROR,
  [CALLBACK_ARGUMENT]: response => response.payload,
  payload: { prospectId, licenseNo, licenseIssuingAuthority }
});

export const setRakezDataLoading = isLoading => ({
  type: SET_RAKEZ_DATA_LOADING,
  payload: { isLoading }
});
export const setRakezData = (data, rawResponse = null) => ({
  type: SET_RAKEZ_DATA,
  payload: { data, rawResponse }
});
export const setRakezError = (key, error, id = "") => ({
  type: SET_RAKEZ_ERROR,
  error,
  payload: { key, error, id }
});
export const resetRakezStates = () => ({
  type: RESET_RAKEZ_STATES
});
export const setRakezFetchDataProcessCompleted = isCompleted => ({
  type: SET_RAKEZ_FETCH_COMPLETED,
  payload: { isCompleted }
});
